export default "/images/vendor/flag-icon-css/flags/1x1/st.svg?95ec25640c911126b02be4702192c98b";